module.exports = __webpack_public_path__ + "static/media/hero.1f26ee23.png";